import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { pluralizeToString } from 'lib/pluralize'
import { useOrder } from 'tripPlanner/hooks/api'
import { TourItem } from 'tripPlanner/types/tripItem'
import { getOrderId } from 'tripPlanner/utils'

export default function useTourV1ItemOccupancyDescription(
  item: TourItem,
): string | undefined {
  const orderId = getOrderId(item)

  const { data: order } = useOrder(orderId)

  if (orderId) {
    // This is an LE tour booking
    if (order) {
      // For tour V1 we have one item per traveller, and all travellers must be adults,
      // so we can just count the number of items
      const tourItems = order.items.filter(
        (orderItem) => orderItem.offerId === item.code,
      )
      if (tourItems.length > 0) {
        return pluralizeToString('adult', tourItems.length)
      }
    }
  } else if (item.savedItemData?.occupancies) {
    // This is a bookmark
    return formatOccupantsShort(item.savedItemData.occupancies)
  }
}
